import React, { useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import RoutineBanner from "./RoutineBanner";
import RoutineProducts from "./RoutineProducts";
import HomeNewsletterSection from '../Home/HomeNewsletterSection';

const YourDailyRoutine = () => {
  // Scroll to top when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <RoutineBanner />
      <RoutineProducts />
      <HomeNewsletterSection />
      {/* <Footer /> */}
    </>
  );
};

export default YourDailyRoutine;